import { render } from "./telephoneInspectionType.vue?vue&type=template&id=438f3bb5&scoped=true"
import script from "./telephoneInspectionType.vue?vue&type=script&lang=js"
export * from "./telephoneInspectionType.vue?vue&type=script&lang=js"

import "./telephoneInspectionType.vue?vue&type=style&index=0&id=438f3bb5&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-438f3bb5"

export default script